<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'myOrderCancel'" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr pt15 mb15">
          <div class="prdState">
            <div>
              <span class="inB bold pointC4">
                <i>{{ orderInfo.preorderDateStr | dateFormatter('.') }}</i>
              </span>
              <span class="inB">
                (주문번호 :
                <i>{{ orderInfo.preorderId }}</i>
                )
              </span>
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="prdList">
            <div class="prdItem xs">
              <div class="imgArea">
                <span class="img imgCover">
                  <img
                    :src="orderInfo.thumbnail ? orderInfo.thumbnail : '/img/error_image.jpg'"
                    :alt="orderInfo.productName"
                    onerror="this.src='/img/error_image.jpg';"
                  />
                </span>
              </div>
              <div class="infoArea">
                <div class="tit row2">
                  <span>{{ orderInfo.productName }}</span>
                </div>
                <div class="txtItem">
                  <span>{{ orderInfo.groupCode }}</span>
                </div>
                <div class="price" v-if="orderInfo.saleType == 'RORT00GE'">
                  <span class="money">
                    월 렌탈료
                    <em>{{ orderInfo.rentalAmount | currency }}</em>
                    원 x {{ orderInfo.rentalPeriod }}개월
                  </span>
                </div>
                <div class="price" v-if="orderInfo.saleType == 'RORT00SE'">
                  <span class="money">
                    <em>{{ orderInfo.saleAmount | currency }}</em>
                    원
                  </span>
                </div>
              </div>
            </div>
            <div class="selectedOpt">
              <div class="txtOpt">
                <div class="opt" v-if="orderInfo.optionCode1Nm != ''">
                  <span class="item">옵션</span>
                  <span class="val">{{ orderInfo.optionCode1Nm }}</span>
                </div>
                <div class="opt">
                  <template v-if="orderInfo.saleType == 'RORT00GE'">
                    <span class="item">렌탈기간</span>
                    <span class="val" style="margin-right: 5px;">
                      {{ orderInfo.releaseDateStr | dateFormatter('.') }}~{{ orderInfo.ownershipDate | dateFormatter('.') }}
                    </span>
                  </template>
                  <span class="item">수량</span>
                  <span class="val">1개</span>
                </div>
                <div class="opt" v-if="orderInfo.dispStatus == 'releaseComp'">
                  <span class="item">설치일</span>
                  <span class="val">{{ orderInfo.releaseDateStr | dateFormatter('.') }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">취소 사유 입력</h2>
          </div>

          <div class="formArea mt15">
            <select v-on:input="changeCancelReason($event.target.value)" v-model="cancelIdx" name="cancelReason" class="ipt" title="취소사유 선택">
              <option value="" selected="selected">선택해주세요</option>
              <option v-for="(cancelCode, index) in cancelCodeList" :value="index">
                {{ cancelCode.codeName }}
              </option>
            </select>

            <textarea
              class="ipt"
              title="글내용 입력(상세 사유를 입력해주세요. (최대 100자))"
              placeholder="상세 사유를 입력해주세요. (최대 100자)"
              v-model="cancelReason"
              :maxlength="100"
              v-if="cancelCode !== ''"
            ></textarea>
          </div>
        </section>

        <section>
          <div class="titArea">
            <h2 class="titH4">환불 예정 금액</h2>
          </div>

          <div class="orderSum">
            <ul class="infoList">
              <li>
                <span class="item">상품 취소금액</span>
                <span class="val">{{ orderRefund.saleAmount | currency }}원</span>
              </li>
              <li>
                <span class="item">배송비 차감</span>
                <span class="val">0원</span>
              </li>
              <li>
                <span class="item">쿠폰할인 차감</span>
                <span class="val">-{{ orderRefund.discountAmount | currency }}원</span>
              </li>
              <li class="total">
                <span class="item">
                  <em class="pointC1">환불 예정 금액</em>
                  <p class="txtXS pointC6">환불 수단</p>
                </span>
                <span class="val">
                  <span class="money pointC1">
                    <em>{{ orderRefund.payAmount | currency }}</em>
                    원
                  </span>
                  <p class="txtXS pointC6 ar">
                    <i>{{ orderRefund.cardName }}[{{ orderRefund.quota }}]/{{ orderRefund.payDate }} 신청</i>
                  </p>
                </span>
              </li>
            </ul>
          </div>

          <ul class="txtList_remark mt15">
            <li>결제금액은 쿠폰할인이 반영되어 결제된 금액입니다.</li>
            <!-- <li>당일 이후 취소 건은 카드사에 따라 3~5영업일 사이에 환불됩니다.</li> -->
          </ul>

          <div class="btnArea">
            <button type="button" class="btn_s" @click="cancelPayment">결제 취소</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->

      <MessagePop v-if="messagePop" @close="close">
        <p v-html="msg"></p>
      </MessagePop>
      <ConfirmPop @cancel="cancel" @close="close" @confirm="confirm" v-if="confirmPop">
        <p v-html="msg"></p>
      </ConfirmPop>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'myOrderCancel',
  components: {
    MessagePop,
    ConfirmPop,
  },
  data() {
    return {
      headerTitle: '결제취소',
      msg: null,
      messagePop: false,
      confirmPop: false,

      orderInfo: {},
      cancelCodeList: [],
      cancelIdx: '',
      cancelCode: '',
      cancelReason: '',
      orderRefund: {},
      completeCancel: false,
    };
  },
  mounted() {
    this.orderInfo = this.$route.params.orderInfo;
    this.selectCommonCodeList();
    this.selectOrderRefundByOrderId();
  },
  methods: {
    selectCommonCodeList() {
      ApiService.service('GET', '/common/code/WMPC', '')
        .then(({ data }) => {
          this.cancelCodeList = data.result[0].codeList;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectOrderRefundByOrderId() {
      ApiService.service('GET', '/order/refund/' + this.orderInfo.preorderId, '')
        .then(({ data }) => {
          console.log(data);
          this.orderRefund = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    changeCancelReason(idx) {
      this.cancelIdx = idx;
      this.cancelCode = '';
      this.cancelReason = '';

      if (idx != '') {
        this.cancelCode = this.cancelCodeList[idx].code;
        this.cancelReason = this.cancelCodeList[idx].codeName;
      }
    },
    validate: function() {
      if (isEmpty(this.cancelCode)) {
        this.msg = '취소사유를 선택해주세요.';
        this.messagePop = true;
        return false;
      }

      return true;
    },
    cancelPayment() {
      if (!this.validate()) {
        return;
      }

      this.msg = '결제 취소하시겠습니까?';
      this.confirmPop = true;
    },
    confirm: function() {
      let reqParam = {
        request: {
          cancelCode: this.cancelCode,
          cancelReason: this.cancelReason,
          orderId: this.orderInfo.preorderId,
          payApprovalNo: this.orderInfo.payApprovalNo,
        },
        serviceType: 'app',
      };

      console.log(reqParam);
      this.confirmPop = false;
      this.$refs.header.loadingStart();
      ApiService.service('DELETE', '/order/pay', reqParam)
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.msg = '취소가 완료되었습니다.';
            this.messagePop = true;
            this.completeCancel = true;
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        })
        .finally(() => {
          if (this.$refs.header.loadingEnd) {
            this.$refs.header.loadingEnd();
          }
        });
    },
    cancel: function() {
      this.confirmPop = false;
      if (this.completeCancel) {
        // this.$router.push({ name: 'myOrderListDetail' });
        this.$router.push({ name: 'myOrderListDetail', params: { preorderId: this.orderInfo.preorderId } });
      }
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      if (this.completeCancel) {
        // this.$router.push({ name: 'myOrderListDetail' });
        this.$router.push({ name: 'myOrderListDetail', params: { preorderId: this.orderInfo.preorderId } });
      }
    },
  },
};
</script>
